<div
  [class.selected]="selectedId === issue.id"
  class="wrapper w-[755px] mb-[20px] cursor-pointer"
>
  <div class="header-section flex gap-[12px] w-full">
    <div class="left w-[48px]">
      <div class="icon-holder flex justify-center items-center">
        <mat-icon [svgIcon]="icon" class="icon" />
      </div>
    </div>
    <div class="right w-10/12">
      <div [innerHTML]="titleHtml" class="heading text-type-6 w-full">
      </div>
      <div class="subheading flex gap-[12px] text-type-14 w-full">
        <div class="name">
          {{
            issue?.createdBy?.first_name + (issue.createdBy?.last_name ? ' ' + issue.createdBy?.last_name[0] + '.' :
              '')
          }}
        </div>
        <div class="last-updated-at">
          {{ issue.updated_at | dateFormat: 'ago-tiny' }} ago
        </div>
      </div>
    </div>
  </div>
  <div [innerHTML]="descriptionHtml" class="content text-type-10">
  </div>
  @if (matchedHintHtml) {
    <div [innerHTML]="matchedHintHtml" class="matched-hint text-type-14">
    </div>
  }
  <div class="status-section flex gap-[20px]">
    <div class="project-details">
      {{ issue?.entity?.name }}
    </div>
    @if (issueTypeLabel) {
      <div class="issue-type text-type-14">{{ issueTypeLabel }}</div>
    }
    <!-- One status pill: the plain open / closed one, or the contractor-workflow stage -->
    @if (!isStageStatus) {
      <div [ngClass]="issue.status" class="status text-type-12">
        <mat-icon [svgIcon]="issue.status + '-issues'" />
        {{ issue.status }}
      </div>
    }
    <app-issue-stage-chip [compact]="true" [issue]="issue" />
  </div>
</div>
